<template>
  <div class="d-flex justify-content-between d-print-none">
    <b-button
      variant="link-link2"
      @click="goBack"
      v-if="this.listView && mxCanViewGeneral"
      size="lg"
      class="mb-2 font-weight-bold"
    >
      <Icon font-size="16" name="arrow-left" />
      {{ $t("back") }}
    </b-button>

    <b-button
      variant="link-text"
      class="text-danger mb-2"
      @click="deleteMeeting"
      size="lg"
      v-if="this.deleteButton"
    >
      <Icon font-size="20" name="delete" />
      {{ $t("delete") }}
    </b-button>
  </div>
</template>
<script>
import Icon from "@/components/Icon/Icon";
import { mapGetters } from "vuex";
import { ROUTE_NAMES } from "@/constants/routeConstants";

export default {
  name: "MobileHeader",
  components: {
    Icon,
  },
  data() {
    return {
      deleteButton: false,
      listView: true,
    };
  },
  computed: {
    ...mapGetters({
      meeting_id: "meeting/getId",
    }),
  },
  watch: {
    $route: function () {
      this.listView = !(
        this.$route.name === ROUTE_NAMES.page_not_found ||
        this.$route.name === ROUTE_NAMES.meetings ||
        this.$route.name === ROUTE_NAMES.forbidden ||
        this.$route.name === ROUTE_NAMES.login
      );
      this.deleteButton = !!(
        this.$route.name === ROUTE_NAMES.voting && this.mxCanEdit
      );
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    deleteMeeting() {
      this.mxConfirmBox(this.$t("meeting.are_you_sure_delete_meeting"), "", {
        cancelTitle: this.$t("back"),
        okTitle: this.$t("delete"),
      }).then((value) => {
        if (value) {
          this.$store.dispatch("meeting/deleteMeeting", this.meeting_id);
          this.$router.go(-1);
        }
      });
    },
  },
};
</script>
